export function convertMetersToMiles(meters: number): number {
  return meters * 0.000621371192;
}
